import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProspifyRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#02b9d2",
		d: "M15.3 4.7a10.6 10.6 0 0 0-5.2 19.8v-9.2a5.2 5.2 0 1 1 5.2 5.2l-1.4-.2V18a3 3 0 0 0 4.5-2.7 3 3 0 0 0-6.1 0v10.2a10.6 10.6 0 1 0 3-20.8m0 9.2q1.3.1 1.5 1.4a1.4 1.4 0 0 1-3 0 1.4 1.4 0 0 1 1.5-1.4m0 10.4-1.4-.1V22l1.4.1a6.8 6.8 0 1 0-6.8-6.8v5.9a9 9 0 0 1-2.2-5.9 9 9 0 1 1 9 9"
	})
});
export default SvgProspifyRegularIcon;
